import React, { Fragment } from 'react';

import { STATUS } from '../config';

import { Button, FormGroup, Input } from '@tencent/spaui';

const Api = (props) => {
  const genButton = () => {
    if (props.status == STATUS.SUCCESS) {
      return (
        <Button disabled>
          <i className="spaui-icon spaui-icon-buttonin spaui-icon-success-sm"></i>
        </Button>
      );
    }
    if (props.status == STATUS.FAIL) {
      return (
        <Button disabled>
          <i className="spaui-icon spaui-icon-buttonin spaui-icon-warning-sm"></i>
        </Button>
      );
    }
    if (props.status == STATUS.PENDING) {
      return (
        <Button disabled>
          <i className="spaui-icon spaui-icon-buttonin spaui-icon-loading-sm"></i>
        </Button>
      );
    }
    return <Button onClick={() => props.doTest(props.value)}>校验</Button>;
  };

  return (
    <Fragment>
      <span className="info-tt">推送地址(必填)</span>
      <div className="info-des api">
        <div className="layout-flex">
          <div className="flex-in">
            <FormGroup>
              <Input placeholder="请输入请求地址" {...props} />
            </FormGroup>
          </div>
          {genButton()}
        </div>
      </div>
    </Fragment>
  );
};

export default Api;
